document.addEventListener("DOMContentLoaded", function () {
    var fullText = document.querySelector('.image-with-text__text-full');
    var smallText = document.querySelector('.image-with-text__text-small');
    var showMoreButton = document.querySelector('.image-with-text__text-toggle');
    if (showMoreButton){
        var translationsAttribute = showMoreButton.getAttribute('translations');
        var translationsObject = JSON.parse(translationsAttribute);
        var showMore = translationsObject.more;
        var showLess = translationsObject.less;
    }

    if (showMoreButton){
        showMoreButton.addEventListener('click', function () {
            if (fullText.style.display != 'block') {
                fullText.style.display = 'block';
                smallText.style.display = 'none';
                showMoreButton.textContent = showLess ;
            } else {
                fullText.style.display = 'none';
                smallText.style.display = 'block';
                showMoreButton.textContent = showMore ;
            }
        });
    }
});